import React, { Component } from "react";
import { Col, Row, Container } from "react-bootstrap";
import BindingStatus from "./BindingStatus";
import { Link } from "react-router-dom";

import "../css/Vault.css";

import Example from "../json/example-trove-cache.json";

import { ReactComponent as ArrowUpSVG } from "../images/svg/arrow_up.svg";
import { ReactComponent as ArrowDownSVG } from "../images/svg/arrow_down.svg";
import { ReactComponent as ArrowUpDownSVG } from "../images/svg/arrow_up_down.svg";
import { ReactComponent as InfoSVG } from "../images/svg/info.svg";
import { ReactComponent as SortSVG } from "../images/svg/sort.svg";

// This LUT maps "ItemType"s from the incoming json data to
// more customer-friendly strings
const ITEM_TYPE_LUT = [
    ["BagOfSingletons", "Bag"],
    ["MountToken", "Mount"],
    ["SoulGem", "Soul Gem"],
    ["129", "Misc"],
    ["Contract", "Hireling"],
    ["CosmeticPetToken", "Cosmetic Pet Token"],
];

const TREASURE_TYPE_LUT = [["Undef", "No Type"]];

class Vault extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            query: "",
            itemType: "",
            treasureType: "",
            sortBy: "name",
            sortDirection: "asc",
            treasureTypes: [],
            itemTypes: [],
            selectedCharacter: "",
            expandedCharacter: "",
            aliases: [],
            characterSortMethod: "",
        };

        this.state.aliases = JSON.parse(
            localStorage.getItem("character-aliases") || "[]"
        );

        this.state.characterSortMethod =
            localStorage.getItem("character-sort-method") || "By last updated";
    }

    handleFile = (e) => {
        const content = e.target.result;
        this.setState({ fileData: content });
    };

    onFileChange = (e) => {
        if (!e.target.files.length) return;
        let reader = new FileReader();
        reader.readAsText(e.target.files[0]);
        reader.onload = this.handleFile;
    };

    // Called when the user clicks on an item
    toggleItemExpanded = (character, item) => {
        let characters = this.state.Characters;
        characters.forEach((char) => {
            if (char === character) {
                character.Items?.forEach((i) => {
                    if (i === item) {
                        if (i.isExpanded === undefined) {
                            i.isExpanded = true;
                        } else {
                            i.isExpanded = !i.isExpanded;
                        }
                    }
                });
            }
        });

        this.setState({ Characters: characters });
    };

    // Toggles between sorting methods
    changeCharacterSortMethod = () => {
        let nextmethod = "";
        if (this.state.characterSortMethod === "By last updated") {
            nextmethod = "By name";
        } else if (this.state.characterSortMethod === "By name") {
            nextmethod = "By last updated";
        }

        this.setState({ characterSortMethod: nextmethod });
        localStorage.setItem("character-sort-method", nextmethod);
    };

    // Function for sorting inventory and bank items
    compare = (a, b) => {
        switch (this.state.sortBy) {
            case "name":
                if (this.state.sortDirection === "asc") {
                    return a.Name.localeCompare(b.Name);
                } else {
                    return b.Name.localeCompare(a.Name);
                }
            case "ml":
                if (a.MinimumLevel === undefined) return 1;
                if (b.MinimumLevel === undefined) return -1;
                if (this.state.sortDirection === "asc") {
                    return a.MinimumLevel - b.MinimumLevel;
                } else {
                    return b.MinimumLevel - a.MinimumLevel;
                }
            case "binding":
                if (this.state.sortDirection === "asc") {
                    return BindingStatus(a.Binding).localeCompare(
                        BindingStatus(b.Binding)
                    );
                } else {
                    return BindingStatus(b.Binding).localeCompare(
                        BindingStatus(a.Binding)
                    );
                }
            case "location":
                if (this.state.sortDirection === "asc") {
                    return this.getItemLocationSortableString(a).localeCompare(
                        this.getItemLocationSortableString(b)
                    );
                } else {
                    return this.getItemLocationSortableString(b).localeCompare(
                        this.getItemLocationSortableString(a)
                    );
                }
            default:
                return a.Name.localeCompare(b.Name);
        }
    };

    // Updates sorting whenever the sort method changes
    // Dependency list: [this.state.sortBy, this.state.sortDirection, this.state.fileData]
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.sortBy !== this.state.sortBy ||
            prevState.sortDirection !== this.state.sortDirection ||
            prevState.fileData !== this.state.fileData ||
            prevState.aliases !== this.state.aliases ||
            prevState.characterSortMethod !== this.state.characterSortMethod
        ) {
            let { Server, Characters } = JSON.parse(this.state.fileData);

            // First load (this should really be made to happen on *any* file load):
            if (prevState.Characters === undefined) {
                // Capture every "itemType" and "treasureType" field from
                // available items to be used to populate the "search" dropdowns
                let itemtypes = [];
                let treasuretypes = [];
                // filter each item and replace names with friendly labels.
                Characters.forEach((char) => {
                    char.Inventory?.forEach((item) => {
                        if (
                            item.ItemType &&
                            !itemtypes.includes(
                                this.getCustomerFacingItemType(item.ItemType)
                            )
                        ) {
                            itemtypes.push(
                                this.getCustomerFacingItemType(item.ItemType)
                            );
                        }
                        if (
                            item.TreasureType &&
                            !treasuretypes.includes(
                                this.getCustomerFacingTreasureType(
                                    item.TreasureType
                                )
                            )
                        ) {
                            treasuretypes.push(
                                this.getCustomerFacingTreasureType(
                                    item.TreasureType
                                )
                            );
                        }
                    });
                    char.Bank?.forEach((item) => {
                        if (
                            item.ItemType &&
                            !itemtypes.includes(
                                this.getCustomerFacingItemType(item.ItemType)
                            )
                        ) {
                            itemtypes.push(
                                this.getCustomerFacingItemType(item.ItemType)
                            );
                        }
                        if (
                            item.TreasureType &&
                            !treasuretypes.includes(
                                this.getCustomerFacingTreasureType(
                                    item.TreasureType
                                )
                            )
                        ) {
                            treasuretypes.push(
                                this.getCustomerFacingTreasureType(
                                    item.TreasureType
                                )
                            );
                        }
                    });
                });
                itemtypes = itemtypes.sort();
                treasuretypes = treasuretypes.sort();
                this.setState({
                    itemTypes: itemtypes,
                    treasureTypes: treasuretypes,
                });
            }

            // For every character read from file...
            for (let i = 0; i < Characters.length; i++) {
                // Consolidate inventory and bank items, then sort them
                Characters[i].Items = [
                    ...(Characters[i].Inventory || []),
                    ...(Characters[i].Bank || []),
                ];
                Characters[i].Items.sort((a, b) => this.compare(a, b));
            }

            // Sort characters based on user preference
            Characters = Characters.sort((a, b) => {
                if (this.state.characterSortMethod === "By name") {
                    if (a.Name == null || b.Name == null) {
                        return 1;
                    }
                    return (this.getAlias(a.Name) || a.Name).localeCompare(
                        this.getAlias(b.Name) || b.Name
                    );
                } else {
                    if (a.LastUpdated == null || b.LastUpdated == null) {
                        return 1;
                    }
                    return new Date(a.LastUpdated) - new Date(b.LastUpdated);
                }
            });

            this.setState({ Server: Server, Characters: Characters });
        }
    }

    // Maps the "headers" array into functional table headers
    header = () => {
        // An array to be mapped to table headers
        let headers = [
            { text: "Item Name", sortMethod: "name", colSpan: 2 },
            { text: "ML", sortMethod: "ml" },
            { text: "Binding", sortMethod: "binding" },
            { text: "Location", sortMethod: "location" },
        ];

        return (
            <tr>
                {headers.map((header, i) => (
                    <th
                        key={i}
                        colSpan={header.colSpan || ""}
                        className="sort-header"
                        onClick={() => {
                            this.state.sortBy === header.sortMethod
                                ? this.setState({
                                      sortBy: header.sortMethod,
                                      sortDirection:
                                          this.state.sortDirection === "asc"
                                              ? "desc"
                                              : "asc",
                                  })
                                : this.setState({
                                      sortBy: header.sortMethod,
                                      sortDirection: "asc",
                                  });
                        }}
                    >
                        {header.text}
                        {this.state.sortBy === header.sortMethod ? (
                            this.state.sortDirection === "asc" ? (
                                <ArrowUpSVG />
                            ) : (
                                <ArrowDownSVG />
                            )
                        ) : (
                            <ArrowUpDownSVG />
                        )}
                    </th>
                ))}
            </tr>
        );
    };

    // Returns "expanded" item information (i.e. Description, Item Type, Treasure Type)
    expandedDiv = (item) => {
        return (
            <span className="item-description-message">
                {item.Description ? (
                    item.Description.split("\\n").map((s, i) => (
                        <span key={i}>
                            <br />
                            {s.replace(/(?:\\q)/g, '"')}
                        </span>
                    ))
                ) : (
                    <span>
                        <br />
                        No description found
                    </span>
                )}
                {/* TODO: Hardness values are incorrect. Removed for now. */}
                {
                    /*(item.Hardness !== undefined && item.Hardness !== 0) ||*/
                    ((item.TreasureType && item.TreasureType !== "Undef") ||
                        item.ItemType) && <br />
                }
                {item.TreasureType && item.TreasureType !== "Undef" && (
                    <span>
                        <br />
                        Treasure Type: {item.TreasureType}
                    </span>
                )}
                {item.ItemType && (
                    <span>
                        <br />
                        Item Type: {item.ItemType}
                    </span>
                )}
                {/* {item.Hardness !== undefined && item.Hardness !== 0 && (
                    <span>
                        <br />
                        Hardness: {item.Hardness}
                    </span>
                )} */}
            </span>
        );
    };

    // Returns the alias of the player if one exists, otherwise returns an empty string
    getAlias = (name) => {
        if (name == null) return "";
        let aliases = this.state.aliases;
        let r = "";
        aliases.forEach((alias) => {
            if (alias[0] === name) r = alias[1];
        });
        return r;
    };

    // Sets the alias of a player
    setAlias = (name, newalias, hard) => {
        let aliases = this.state.aliases;
        let exists = false;
        aliases.forEach((alias) => {
            if (alias[0] === name) {
                exists = true;
                alias[1] = newalias;
            }
        });
        if (!exists) {
            aliases.push([name, newalias]);
        }
        localStorage.setItem("character-aliases", JSON.stringify(aliases));

        if (hard) {
            this.setState({ aliases: [...aliases] });
        } else {
            this.setState({ aliases: aliases });
        }
    };

    // Returns a location string for display in the item table
    // e.g. "Bank: 2/3/1"
    getItemLocationString = (item) => {
        if (item.Name === "Platinum") {
            return "Character";
        }

        if (item.Container === "Equipped") {
            return "Equipped";
        }

        let trc = `${item.Tab}/${item.Row}/${item.Column}`;
        if (item.Container === "Inventory") {
            return `Inv: ${trc}`;
        } else {
            return `Bank: ${trc}`;
        }
    };

    // Returns an easily-sortable location string for sorting purposes
    getItemLocationSortableString = (item) => {
        if (item.Name === "Platinum") {
            return "0";
        }

        if (item.Container === "Equipped") {
            return "1";
        }

        let trc = `${item.Tab}/${item.Row}/${item.Column}`;
        if (item.Container === "Inventory") {
            return `2/${trc}`;
        } else {
            return `3/${trc}`;
        }
    };

    // This function maps an item object to an item row
    itemRow = (char, item, i) => {
        return (
            <tr
                className="inventory-item"
                key={i}
                onClick={() => this.toggleItemExpanded(char, item)}
            >
                <td className="item-icon">
                    <img src={`${item.IconSource}`} alt="Icon" />
                </td>
                <td className="inventory-item item-name-container">
                    <span className="inventory-item item-name">
                        {item.Name}
                        {item.Quantity ? ", Qty " + item.Quantity : null}
                    </span>
                    {item.isExpanded && this.expandedDiv(item)}
                </td>
                <td>
                    {item.MinimumLevel !== undefined
                        ? +item.MinimumLevel
                        : null}
                </td>
                <td>{BindingStatus(item.Binding)}</td>
                <td>{this.getItemLocationString(item)}</td>
            </tr>
        );
    };

    // Maps ItemType to a customer-friendly string
    getCustomerFacingItemType(type) {
        let t = type;
        ITEM_TYPE_LUT.forEach((pair) => {
            if (pair[0] === type) {
                t = pair[1];
            }
        });
        return t;
    }

    getCustomerFacingTreasureType(type) {
        let t = type;
        TREASURE_TYPE_LUT.forEach((pair) => {
            if (pair[0] === type) {
                t = pair[1];
            }
        });
        return t;
    }

    // Maps customer-friendly string to ItemType
    // and sets the state
    setItemType(type) {
        let t = type;
        ITEM_TYPE_LUT.forEach((pair) => {
            if (pair[1] === type) {
                t = pair[0];
            }
        });
        this.setState({ itemType: t });
    }

    setTreasureType(type) {
        let t = type;
        TREASURE_TYPE_LUT.forEach((pair) => {
            if (pair[1] === type) {
                t = pair[0];
            }
        });
        this.setState({ treasureType: t });
    }

    // If the users is searching (using the search box or dropdowns)
    // this returns a table of the search results. Otherwise returns nothing
    renderSearchResults = () => {
        if (
            !this.state.query.replace(/\s/g, "") &&
            !this.state.itemType &&
            !this.state.treasureType
        )
            return;

        let results = [];
        let itemmatchcount = 0;
        this.state.Characters.forEach((char) => {
            let matcheditems = [];
            char.Items.forEach((item) => {
                if (
                    item.Name.toLowerCase().includes(
                        this.state.query.toLowerCase()
                    ) &&
                    (this.state.itemType
                        ? item.ItemType?.includes(this.state.itemType)
                        : true) &&
                    (this.state.treasureType
                        ? item.TreasureType?.includes(this.state.treasureType)
                        : true)
                ) {
                    if (itemmatchcount + matcheditems.length < 100) {
                        matcheditems.push(item);
                    }
                }
            });

            if (matcheditems.length) {
                itemmatchcount += matcheditems.length;
                results.push({ Character: char, Items: matcheditems });
            }
        });

        return (
            <div className="cache-wrapper">
                <div className="flex-row character-info-header">
                    {results.length ? (
                        <span>
                            {itemmatchcount >= 100
                                ? `Showing the first ${itemmatchcount}`
                                : itemmatchcount}{" "}
                            matching items across {results.length} character
                            {results.length === 1 ? "" : "s"}
                        </span>
                    ) : (
                        <span>No items matched your search query</span>
                    )}
                </div>
                <div className="character-vault-container">
                    {results.length !== 0 &&
                        results.map((result, i) => (
                            <table key={i} className="character-vault">
                                <tbody>
                                    <tr>
                                        <th
                                            colSpan="5"
                                            className="character-header"
                                        >
                                            <span>
                                                {this.getAlias(
                                                    result.Character.Name
                                                )
                                                    ? `${this.getAlias(
                                                          result.Character.Name
                                                      )} (${
                                                          result.Character.Name
                                                      })`
                                                    : result.Character.Name}
                                            </span>
                                        </th>
                                    </tr>
                                    {this.header()}
                                    {result.Items.map((item, i) =>
                                        this.itemRow(result.Character, item, i)
                                    )}
                                </tbody>
                            </table>
                        ))}
                </div>
            </div>
        );
    };

    // Renders a character's inventory
    renderCharacterInventory() {
        if (!this.state.selectedCharacter) return;
        let char = this.state.Characters.filter(
            (char) => char.Name === this.state.selectedCharacter
        )[0];

        return (
            char && (
                <div className="cache-wrapper">
                    <div className="flex-row character-info-header">
                        <span>
                            {this.getAlias(char.Name)
                                ? `${this.getAlias(char.Name)} (${char.Name})`
                                : char.Name}
                        </span>
                        <span className="character-info-name">
                            | {+char.Items?.length || 0} items
                        </span>
                        <span className="character-info-last-updated">
                            Last updated:{" "}
                            {new Date(char.LastUpdated).toUTCString()}
                        </span>
                    </div>
                    <div className="character-vault-container">
                        <table className="character-vault">
                            <tbody>
                                {char.Items?.length ? (
                                    <>
                                        {this.header()}
                                        {char.Items.filter(
                                            (item) =>
                                                item.Name.toLowerCase().includes(
                                                    this.state.query.toLowerCase()
                                                ) &&
                                                (this.state.itemType
                                                    ? item.ItemType?.includes(
                                                          this.state.itemType
                                                      )
                                                    : true) &&
                                                (this.state.treasureType
                                                    ? item.TreasureType?.includes(
                                                          this.state
                                                              .treasureType
                                                      )
                                                    : true)
                                        ).map((item, i) =>
                                            this.itemRow(char, item, i)
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td colSpan="5">No items found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        );
    }

    fileData = () => {
        if (this.state.Server && this.state.Characters) {
            return (
                <div className="app-wrapper">
                    <div className="flex-row">
                        <div className="flex-row filter-cache-search-box">
                            <div className="flex-column">
                                <label
                                    className="small-title"
                                    htmlFor="search-query"
                                >
                                    Search
                                </label>
                                <input
                                    id="search-query"
                                    className="search-query"
                                    value={this.state.query}
                                    onChange={(e) => {
                                        this.setState({
                                            query: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div className="flex-column">
                                <label
                                    className="small-title"
                                    htmlFor="select-treasure-type"
                                >
                                    Treasure Type
                                </label>
                                <select
                                    id="select-treasure-type"
                                    onChange={(e) => {
                                        this.setTreasureType(e.target.value);
                                    }}
                                >
                                    <option></option>
                                    {this.state.treasureTypes.map((type) => (
                                        <option key={type}>{type}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="flex-column">
                                <label
                                    className="small-title"
                                    htmlFor="select-item-type"
                                >
                                    Item Type
                                </label>
                                <select
                                    id="select-item-type"
                                    onChange={(e) => {
                                        this.setItemType(e.target.value);
                                    }}
                                >
                                    <option></option>
                                    {this.state.itemTypes.map((type) => (
                                        <option key={type}>{type}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="flex-row">
                        <div
                            className={
                                "flex-column character-list" +
                                (this.state.Characters.filter(
                                    (char) => char.ShowInfo
                                ).length ||
                                this.state.selectedCharacter === "" ||
                                this.state.expandedCharacter !== ""
                                    ? " stay-open"
                                    : "")
                            }
                        >
                            <div
                                className="flex-row sort-container"
                                onClick={() => this.changeCharacterSortMethod()}
                            >
                                <SortSVG />
                                <span className="sort-method-message">
                                    {this.state.characterSortMethod}
                                </span>
                            </div>
                            {this.state.Characters?.map(
                                (char, i) =>
                                    char.Name && (
                                        <div
                                            key={i}
                                            className={
                                                "character" +
                                                (char.Name ===
                                                this.state.selectedCharacter
                                                    ? " selected"
                                                    : "")
                                            }
                                            onClick={() => {
                                                this.setState({
                                                    selectedCharacter:
                                                        char.Name,
                                                });
                                                this.state.Characters.forEach(
                                                    (c) => {
                                                        if (
                                                            c.Name !== char.Name
                                                        ) {
                                                            c.ShowInfo = false;
                                                        }
                                                    }
                                                );
                                            }}
                                        >
                                            <div className="flex-row">
                                                <span className="character-name">
                                                    {this.getAlias(char.Name) ||
                                                        char.Name}
                                                </span>
                                                <InfoSVG
                                                    className="flex-row character-info-icon"
                                                    onClick={() => {
                                                        if (
                                                            this.state
                                                                .expandedCharacter ===
                                                            char.Name
                                                        ) {
                                                            this.setState({
                                                                expandedCharacter:
                                                                    "",
                                                            });
                                                        } else {
                                                            this.setState({
                                                                expandedCharacter:
                                                                    char.Name,
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                            {this.state.expandedCharacter ===
                                                char.Name && (
                                                <div className="character-info-container">
                                                    <div className="character-info-container-section">
                                                        <span className="small-title">
                                                            Inventory
                                                        </span>
                                                        <span>
                                                            {char.Inventory
                                                                ?.length ||
                                                                0}{" "}
                                                            items
                                                        </span>
                                                    </div>
                                                    <div className="character-info-container-section">
                                                        <span className="small-title">
                                                            Bank
                                                        </span>
                                                        <span>
                                                            {char.Bank
                                                                ?.length ||
                                                                0}{" "}
                                                            items
                                                        </span>
                                                    </div>
                                                    <div className="character-info-container-section">
                                                        <span className="small-title">
                                                            Last updated
                                                        </span>
                                                        <span>
                                                            {new Date(
                                                                char.LastUpdated
                                                            ).toUTCString()}
                                                        </span>
                                                    </div>
                                                    <div className="character-info-container-section">
                                                        <span className="small-title">
                                                            Alias
                                                        </span>
                                                        <input
                                                            placeholder={
                                                                char.Name
                                                            }
                                                            value={this.getAlias(
                                                                char.Name
                                                            )}
                                                            onChange={(e) =>
                                                                this.setAlias(
                                                                    char.Name,
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                            onBlur={(e) =>
                                                                setTimeout(
                                                                    () => {
                                                                        this.setAlias(
                                                                            char.Name,
                                                                            e
                                                                                .target
                                                                                .value,
                                                                            true
                                                                        );
                                                                    },
                                                                    100
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    )
                            )}
                        </div>
                        <div className="item-container">
                            {this.renderSearchResults() ||
                                (this.state.selectedCharacter === "" ? (
                                    <div className="empty-set-message-container">
                                        <center>
                                            <span className="empty-set-message">
                                                Search for an item
                                                <br />
                                                or select a character
                                            </span>
                                        </center>
                                    </div>
                                ) : (
                                    this.renderCharacterInventory()
                                ))}
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="choose">
                    <h4>
                        Please click the browse button and locate your Trove
                        JSON file
                        <br />
                        to display the items in your Vault Cache.
                    </h4>
                </div>
            );
        }
    };

    async downloadExample() {
        const fileName = "example-trove-cache.json";
        const json = JSON.stringify(Example);
        const blob = new Blob([json], { type: "application/json" });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = href;
        link.download = fileName + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    render() {
        return (
            <Container>
                {!this.state.Characters && (
                    <Row>
                        <Col className="faqContainer">
                            <div>
                                <h3>Vault Cache</h3>
                            </div>
                            <details>
                                <summary>What is Vault Cache?</summary>
                                <div className="faq__content">
                                    <p>
                                        An offline Trove JSON file parser. It
                                        allows you to open your Trove data file
                                        from your computer's local storage.
                                    </p>
                                </div>
                            </details>
                            <details>
                                <summary>How do I use it?</summary>
                                <div className="faq__content">
                                    <p>
                                        This tool requires a JSON file that has
                                        been generated from Trove. Follow the
                                        steps below to create your first file or
                                        download an example here:{" "}
                                        <Link
                                            to="#"
                                            onClick={this.downloadExample}
                                        >
                                            example cache
                                        </Link>
                                    </p>
                                    <ul>
                                        <li>
                                            Step 1: Use the official Trove
                                            plugin while playing DDO and upload
                                            a character.
                                        </li>
                                        <li>
                                            Step 2: Browse to `%AppData%\Dungeon
                                            Helper\plugins\Trove\` and open the
                                            file with the server name your
                                            character plays on.
                                        </li>
                                    </ul>
                                </div>
                            </details>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col className="vaultCache">
                        <div>
                            <input type="file" onChange={this.onFileChange} />
                        </div>
                        {this.fileData()}
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Vault;
